import { api } from "@/api/factory";

import type { PageSettings } from '@/types/Page'

class Series {
  private pageSettings:PageSettings

  constructor() {
    this.pageSettings = {
            page: 1,
            per_page: 30
        };
  }

  getListSeries(filter: any = {}, currentPage = null) {
    let search = null;
    let category = null;

    if(filter.name) {
      search = filter.name
    } else if(filter.search) {
      search = filter.search
    }

    if(filter.category) {
      category = filter.category
    } else if (filter.categories) {
      category = filter.categories
    }

    if(!filter.sortType) {
      filter.sortType = 'desc';
    }

    return api({
      url: "/v1/content-manager/series",
      method: "GET",
      params: {
        page: currentPage ? currentPage : this.pageSettings.page,
        per_page: this.pageSettings.per_page,
        year: filter.year ? [filter.year] : null,
        categories: category ? [category] : null,
        search: search,
        sort_by: filter.sort_by || null,
        status: filter.status || null,
        mine: filter.mine ? '1' : null,
        sort_order: filter.sortType ? filter.sortType : null,
      },
    });
  }
}

export default Series;
